export default [
  {
    name: `Майка`,
    table: [
      [`Размер`, `3XS`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`],
      [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`, `52`, `54`, `56`, `58`],
      [`Грудь`, `88`, `92`, `96`, `100`, `104`, `108`, `112`, `116`, `118`, `124`],
      [`Длина`, `65`, `67`, `70`, `72`, `75`, `78`, `80`, `83`, `86`, `89`]
    ]
  },
  {
    name: `Шорты`,
    table: [
      [`Размер`, `3XS`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`],
      [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `48`, `50`, `52`, `54`, `56`, `58`],
      [`Объём по верху`, `95`, `99`, `103`, `107`, `111`, `115`, `119`, `123`, `127`, `131`],
      [`Длина по боковому шву`, `51`, `53`, `55`, `57`, `59`, `61`, `63`, `65`, `67`, `69`],
      [`Объём по низу штанины`, `54`, `56`, `58`, `60`, `62`, `64`, `66`, `68`, `70`, `72`]
    ]
  }
];
